import useTeams from '../../useTeams';
import { LBButton, LBXIcon } from '@linearb/buzz';

const Header = ({ title }) => {
  const { goBack } = useTeams();

  return (
    <div className='flex flex-row justify-between items-center'>
      <h1 className='text-2xl'>{title}</h1>
      <LBButton variant='ghost' size='icon' onClick={goBack}>
        <LBXIcon />
      </LBButton>
    </div>
  );
};

export default Header;
